import PubSubUtils from '../../utils/pubsub-utils';
import APP_CONSTANTS from '../../constants';
import type { DxAPIResponseObject, BlendedUICreateStageCompletedInfo } from '../types';

export const publishCreateStageDoneEvent = (data: BlendedUICreateStageCompletedInfo) => {
  /* publish create stage info to infinity for case tracking */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.CASE_EVENTS.CREATE_STAGE_DONE, data);
};

export const publishExpressLocalActionSubmitEvent = (data: { submitResponse: DxAPIResponseObject }) => {
  /* publishing event to notify, the express local action is submitted */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.EVENT_EXPRESS_LOCALACTION, data);
};

export const publishErrorOnFinishAssignment = (data: { errorType: string }) => {
  /* publishing event to notify the finish assignment validation failed */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.ERROR_ON_FINISH_ASSIGNMENT, data);
};
export const publishLocalActionSubmit = (data: { updateState: boolean }) => {
  /* publishing event to notify, the local action is submitted */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.EVENT_LOCALACTION_SUBMISSION, data);
};
